<template>
  <div v-if="visible" class="mask" @click.self="$emit('close')">
    <div class="modal">
      <h3>修改密码</h3>
      <input v-model="form.oldPwd" type="password" placeholder="旧密码" />
      <input v-model="form.newPwd" type="password" placeholder="新密码" />
      <input v-model="form.confirmPwd" type="password" placeholder="确认新密码" />
      <button class="main-btn" @click="submitUpdate">确认修改</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "PasswordModal",
  props: { visible: { type: Boolean, default: false } },
  data() {
    return {
      form: { oldPwd: "", newPwd: "", confirmPwd: "" }
    };
  },
  methods: {
    submitUpdate() {
      if (!this.form.oldPwd || this.form.newPwd.length < 6) {
        window.alert("密码长度至少 6 位");
        return;
      }
      if (this.form.newPwd !== this.form.confirmPwd) {
        window.alert("两次输入密码不一致");
        return;
      }
      window.alert("模拟修改成功");
      this.form = { oldPwd: "", newPwd: "", confirmPwd: "" };
      this.$emit("close");
    }
  }
};
</script>
